module.exports = __webpack_public_path__ + "img/6.af3b8097.jpg";